import { Button, Grid } from "@material-ui/core";
import { DateTime } from "luxon";
import { InternalOnboardingTimeline } from "../../../graphql/models";
import { OnboardingTimelineRowComponent } from "./onboarding_timeline_row";

export interface OnboardingTimelineComponentProps {
  value: InternalOnboardingTimeline[];
  onChange: (items: InternalOnboardingTimeline[]) => void;
}

export function OnboardingTimelineComponent(
  props: OnboardingTimelineComponentProps
) {
  const { value } = props;
  const array = value ?? [];

  const newRow = () => {
    const item: InternalOnboardingTimeline = {
      hiddenDate: DateTime.now().toJSDate(),
      description: "",
      i18n: {},
      isNewRow: true,
    };
    const newArray = [...array, item];
    props.onChange(newArray);
  };

  const updateRow = (row: InternalOnboardingTimeline, index: number) => {
    const rows = [...array];
    rows.splice(index, 1, row);
    props.onChange(rows);
  };

  /*
  const sorted = [...value].sort((item1, item2) => {
    return item1.hiddenDate.valueOf() - item2.hiddenDate.valueOf();
  });
  console.log(`sorted is `, sorted); */

  return (
    <fieldset style={{ borderRadius: "1rem" }}>
      <legend>Timeline</legend>
      {array.map((row, i) => {
        return (
          <Grid
            item
            xs={12}
            key={`apt_timeline_${i}`}
            style={{ margin: "0 10px" }}
          >
            <OnboardingTimelineRowComponent
              row={row}
              index={i}
              onChange={updateRow}
            />
          </Grid>
        );
      })}
      <Grid item xs={12} style={{ marginTop: "1rem", textAlign: "center" }}>
        <Button onClick={newRow} variant="outlined">
          Aggiungi nuova riga alla timeline
        </Button>
      </Grid>
    </fieldset>
  );
}
